/* eslint-disable react/no-array-index-key */
import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';

export default function TestInstancesSkeleton({
  loading,
  error,
  products = 2,
  assessments = 2
}: {
  loading?: boolean;
  error?: boolean;
  products?: number;
  assessments?: number;
}): ReactElement {
  const errorMessage = error ? 'fetching assessments failed' : '';
  return (
    <div
      role="alert"
      aria-live="polite"
      aria-busy={loading}
      aria-label={loading ? 'fetching assessments' : errorMessage}
      data-testid="test-instances-skeleton"
    >
      {Array.from({ length: products }).map((_unused_1, p) => (
        <div
          key={`product-${p}`}
          className={clsx('mx-0 my-2 mx-0 card skeleton', { loading, error })}
        >
          <div className="fw-bold card-header">
            <h3
              className={clsx('card-header-title p-0 m-0 skeleton-box', { loading, error })}
              style={{ width: '25ch' }}
              aria-hidden
            />
          </div>
          <div className="card-body">
            <div className="row">
              {Array.from({ length: assessments }).map((_unused_2, a) => (
                <div key={`assessment-${p}-${a}`} className="col-sm-12 col-md-6 col-lg-4">
                  <div className={clsx('mb-2 card skeleton', { loading, error })}>
                    <div className="card-header">
                      <h4
                        className={clsx('h6 p-0 m-0 skeleton-box', { loading, error })}
                        style={{ width: '20ch' }}
                        aria-hidden
                      />
                    </div>
                    <div className="card-body">
                      <table className="table table-sm">
                        <tbody>
                          {Array.from({ length: 5 }).map((_unused_3, r) => (
                            <tr key={`row-${p}-${a}-${r}`}>
                              <td
                                className={clsx('skeleton-box', { loading, error })}
                                style={{ width: '30ch' }}
                              />
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
